import React, { useEffect, useState } from "react";

import styles from "./Dashboard.module.scss";

import Input from "@material-ui/core/Input";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

import Grid from "../../components/Grid";
import { apiRequest } from "../../utils/api";

import BarChart from "../../components/BarChart";
import BarChartStacked from "../../components/BarChartStacked";
import GetCoaches from "../../components/GetCoaches/";
import RadialChart from "../../components/RadialChart";
import RecentActivities from "../../components/RecentActivities";
import TaskWidget from "../../components/TaskWidget";

import { withStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import InfoIcon from "@material-ui/icons/InfoRounded";
import { useTranslation } from "react-i18next";
import ComplianceRate from "../../components/CompianceRate";
import DashboardMetrics from "../../components/DashboardMetrics";
import ReportDownload from "../../components/ReportDownload";
import { IsCoordinator } from "../../config/Roles";
import { useCampaign } from "../../context/campaign";
import { getLocalValue } from "../../utils/auth";
import getUserIP, { formatIPJSON } from "../../utils/getUserIP";
const XlsxTooltip = withStyles(theme => ({
  tooltip: {
    backgroundColor: "white",
    color: "rgba(0, 0, 0, 0.87)",
    fontSize: theme.typography.pxToRem(12),
    border: "1px solid #9e9e9e",
    boxShadow: "0 4px 6px -1px rgb(0 0 0 / 0.1)",
  },
}))(Tooltip);
const CampaignDashboard = () => {
  const { t } = useTranslation();
  const {
    Parser,
    transforms: { unwind },
  } = require("json2csv");
  const [filterValue, setFilterValue] = useState(["monthly"]);
  const { selectedCampaign } = useCampaign();
  const coach_id = getLocalValue("uid");
  const userFullName = getLocalValue("u_fullname");
  const filterBy = ["monthly", "quarterly", "yearly"];
  const [metricsValue, setMetricsValue] = useState(null);
  const [campaignDashboardMetrics, setCampaignDashboardMetrics] =
    useState(null);
  const [sessionTypeMetrics, setSessionTypeMetrics] = useState(null);
  const [barChartStackedData, setBarChartStackedData] = useState(null);
  const [compareValue, setCompareValue] = useState(coach_id);
  const [coachList, setCoachList] = useState(null);
  const [upcomingTask, setUpcomingTask] = useState(null);
  const [recentActivities, setRecentActivities] = useState(null);
  const [overdueTask, setOverdueTask] = useState(null);
  const [open, setOpen] = React.useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [ops, setOps] = useState("OP-"); // Default to '1' (Operations Only)
  const [reporting, setReporting] = useState(0); // Default to '1' (Operations Only)
  const anchorRef = React.useRef(null);
  const [userIP, setUserIP] = useState(null);

  useEffect(() => {
    getUserIP().then(res => setUserIP(formatIPJSON(res)));
  }, []);

  const handleChange = event => {
    setFilterValue(event.target.value);
  };

  const handleToggle = () => {
    setDialogOpen(prevOpen => !prevOpen);
  };

  function handleListKeyDown(event) {
    if (event.key === "Tab") {
      event.preventDefault();
      setOpen(false);
    }
  }

  const getCampaignDashboardMetrics = () => {
    apiRequest
      .get(
        `/api/getCampaignManagerDashboardMetrics?coach_id=${compareValue}&filter=${filterValue}&campaign_id=${selectedCampaign}&type=${ops}&report=${reporting}`
      )
      .then(response => {
        if (response.status === 200) {
          const data = response.data.data;
          setMetricsValue(data);
        }
      })
      .catch(error => { });
  };

  const getCampaignCoachesTaskMetrics = () => {
    apiRequest
      .get(
        `/api/getCampaignCoachesTaskMetrics?campaign_id=${selectedCampaign}&type=${ops}&report=${reporting}`
      )
      .then(response => {
        if (response.status === 200) {
          const data = response.data.data;
          setOverdueTask(data.overdue_task);
          setRecentActivities(data.recent_activities);
          setUpcomingTask(data.upcoming_task);
        }
      })
      .catch(error => { });
  };

  const getSessionTypeMetrics = () => {
    apiRequest
      .get(
        `/api/getCampaignManagerSessionTypeMetrics?coach_id=${compareValue}&filter=${filterValue}&campaign_id=${selectedCampaign}&type=${ops}&report=${reporting}`
      )
      .then(response => {
        if (response.status === 200) {
          const data = response.data.data;
          setSessionTypeMetrics(data);
        }
      })
      .catch(error => { });
  };

  const getSessionDuration = () => {
    apiRequest
      .get(
        `/api/getCampaignManagerSessionDuration?coach_id=${coach_id}&filter=${filterValue}&campaign_id=${selectedCampaign}&type=${ops}&report=${reporting}`
      )
      .then(response => {
        if (response.status === 200) {
          const data = response.data.data;
          setBarChartStackedData(data);
        }
      })
      .catch(error => { });
  };

  const getCoachName = coachId => {
    if (coachList) {
      const selectedObj = coachList.filter(item => item.uid === coachId);
      return selectedObj.length ? selectedObj[0].u_fullname : userFullName;
    } else {
      return userFullName;
    }
  };

  const [complianceMetricsValue, setComplianceMetricsValue] = useState(null);

  const getCampaignCoachedSessionMatrics = () => {
    apiRequest
      .get(
        `/api/getCampaignCoachedSessionMatrics?uid=${coach_id}&campaign_id=${selectedCampaign}&type=${ops}&report=${reporting}`
      )
      .then(response => {
        if (response.status === 200) {
          const data = response.data.data;
          setCampaignDashboardMetrics(data);
        }
      })
      .catch(error => { });
  };

  const getCampaignComplianceMetrics = () => {
    apiRequest
      .get(
        `/api/getCampaignManagerDashboarddataMetrics?campaign_id=${selectedCampaign}&filter=${filterValue}&type=${ops}&report=${reporting}`
      )
      .then(response => {
        if (response.status === 200) {
          const data = response.data.data;
          setComplianceMetricsValue(data);
        }
      })
      .catch(error => { });
  };

  useEffect(() => {
    if (selectedCampaign) {
      getCampaignComplianceMetrics();
      getCampaignDashboardMetrics();
      getSessionTypeMetrics();
      getSessionDuration();
      getCampaignCoachesTaskMetrics();
      getCampaignCoachedSessionMatrics();
    }
  }, [filterValue, compareValue, selectedCampaign, ops, reporting]);

  const handleCompareValueChange = event => {
    const value = event.target.value; // Get the numeric value (1 or 2)
    setOps(value);
  };

  const handleReportingValueChange = event => {
    const value = event.target.value; // Get the numeric value (1 or 2)
    setReporting(value);
  };

  return (
    <div className={styles.detailsContainer}>
      {/* <button
        className={styles.downloadButton}
        ref={anchorRef}
        aria-controls={open ? "menu-list-grow" : undefined}
        aria-haspopup="true"
        onClick={handleToggle}
      >
        <GetAppOutlinedIcon fontSize="small" />
        {t("dashboard.coach.report")}
      </button> */}
      <div className={styles.row}>
        <div className={styles.taskStatusActivitiesWrapper}>
          <div className={styles.upcomingTask}>
            <TaskWidget
              taskList={upcomingTask}
              upcoming
              itemLabel="coach"
              itemCount="count"
              linkID="coach_id"
              nameParam="coach"
            />
          </div>
          <TaskWidget
            taskList={overdueTask}
            overdue
            itemLabel="coach"
            itemCount="count"
            linkID="coach_id"
            nameParam="coach"
          />
          <RecentActivities activitiesList={recentActivities} />
        </div>
      </div>
      <div className={styles.rows} style={{ justifyContent: "center" }}>
        <div className={styles.deptSection}>
          <h4 className={`${styles.sectionHeadlist}`}>
            {t("dashboard.coach.department")}
          </h4>
          <div style={{ display: "inline-block" }}>
            <Select
              className={styles.formSelect}
              searchable={true}
              value={ops}
              onChange={handleCompareValueChange}
            >
              <MenuItem key={"OP-"} value="OP-">
                Operations Only
              </MenuItem>
              <MenuItem key={"ALL-OP"} value="ALL">
                Operations & Non-Operations
              </MenuItem>
            </Select>
          </div>
        </div>
        <div className={styles.deptSection}>
          <h4 className={`${styles.sectionHeadlist}`}>
            {t("dashboard.coach.reportingLine")}
          </h4>
          <div style={{ display: "inline-block" }}>
            <Select
              className={styles.formSelect}
              searchable={true}
              value={reporting}
              onChange={handleReportingValueChange}
            >
              <MenuItem key={0} value="0">
                Direct reporting
              </MenuItem>
              <MenuItem key={1} value="1">
                Direct reporting & Manually Tagged
              </MenuItem>
            </Select>
          </div>
        </div>
      </div>
      <div className={styles.row}>
        <h4 className={`${styles.sectionHead} ${styles.bold}`}>
          {t("dashboard.coach.campaignSession")}
        </h4>
        {selectedCampaign && campaignDashboardMetrics && (
          <DashboardMetrics data={campaignDashboardMetrics} />
        )}
      </div>
      <div className={styles.row}>
        <h4 className={`${styles.sectionHead}`}>
          {t("dashboard.coach.showResultFor")}
          <Select
            className={styles.sectionFilter}
            value={filterValue}
            onChange={handleChange}
            input={<Input />}
            IconComponent={ExpandMoreIcon}
          >
            {filterBy.map(filter => (
              <MenuItem key={filter} value={filter}>
                {filter}
              </MenuItem>
            ))}
          </Select>
        </h4>
        {selectedCampaign && (
          <Grid>
            <RadialChart
              theme={"#D55757"}
              percentage="80"
              title={t("dashboard.coach.happiness")}
              label={`${t(
                "dashboard.coach.ratedSession"
              )} <span>({{chartValue}})</span> / Unrated session <span>({{secondParam}})</span> / ${t(
                "dashboard.coach.totalSession"
              )} <span>({{totalValue}})</span>`}
              frequency={filterValue}
              api={`getCampaignHappinessDetails?campaign_id=${selectedCampaign}&filter=${filterValue}&type=${ops}&report=${reporting}`}
              average="average_rated_sessions"
              totalValue="total_sessions"
              chartValue="total_rated_sessions"
              secondParam="total_unrated_sessions"
              campaign={selectedCampaign}
            />
            <RadialChart
              theme={"#FF9C12"}
              title={t("dashboard.coach.complimentLikes")}
              label={`${t(
                "dashboard.coach.likes"
              )} <span>({{chartValue}})</span> / ${t(
                "dashboard.coach.totalComplements"
              )} <span>({{totalValue}})</span>`}
              frequency={filterValue}
              api={`getCampaignComplimentDetails?campaign_id=${selectedCampaign}&filter=${filterValue}&type=${ops}&report=${reporting}`}
              average="average_liked_compliments"
              totalValue="total_compliments"
              chartValue="total_liked_compliments"
              campaign={selectedCampaign}
            />
            <RadialChart
              theme={"#13C77A"}
              percentage="73"
              title={t("dashboard.coach.success")}
              label={`${t(
                "dashboard.coach.passRate"
              )} <span>({{chartValue}})</span> / ${t(
                "dashboard.coach.totalSubjects"
              )} <span>({{totalValue}})</span>`}
              frequency={filterValue}
              api={`getCampaignSuccessDetails?campaign_id=${selectedCampaign}&filter=${filterValue}&type=${ops}&report=${reporting}`}
              responseKey=""
              average="average_success"
              totalValue="total_coached_subject"
              chartValue="total_passed_subject"
              campaign={selectedCampaign}
            />
            <RadialChart
              theme={"#13C77A"}
              percentage="73"
              title={t("dashboard.personal.kpisuccess")}
              label={`${t(
                "dashboard.personal.passRate"
              )} <span>({{chartValue}})</span> / ${t(
                "dashboard.personal.totalSubjects"
              )} <span>({{totalValue}})</span>`}
              frequency={filterValue}
              api={`getCampaignSuccessDetails?campaign_id=${selectedCampaign}&filter=${filterValue}&type=${ops}&report=${reporting}`}
              responseKey=""
              average="average_target_kpi_success"
              totalValue="totalKpiSubjects"
              chartValue="kpi_success_rate"
            />
          </Grid>
        )}
      </div>
      <div className={styles.row}>
        <h4 className={`${styles.sectionHead}`}>
          {t("dashboard.coach.comparedTo")}
          <GetCoaches
            style="inline-block"
            isCampaign={selectedCampaign}
            className={styles.comparingFilter}
            defaultItem={{ value: coach_id, label: userFullName }}
            value={compareValue}
            getCoachList={coachLists => {
              setCoachList(coachLists);
            }}
            handleChange={val => {
              setCompareValue(val);
            }}
          />
        </h4>
        {metricsValue ? (
          <Grid>
            <BarChart
              title={t("dashboard.coach.mostCoachedSubjects")}
              colors={["#13C77A", "#8FDEB2"]}
              fontColors={["#212121", "#212121"]}
              legends={[
                <span>
                  {t("dashboard.coach.teamAverage")}
                  {""}
                  <XlsxTooltip
                    arrow
                    title={t("dashboard.tooltip.teamAverage")}
                    placement="right"
                  >
                    <InfoIcon
                      className={styles.infoIcon}
                      fontSize="small"
                    ></InfoIcon>
                  </XlsxTooltip>
                </span>,
                t("dashboard.coach.coach"),
              ]}
              maxValue={metricsValue.max_value}
              data={metricsValue.mostCoachedSubjects}
              labelX="Subjects"
              labelY="Sessions"
              hasFilter
            />
            <BarChart
              title={t("dashboard.coach.mostFailedSubjects")}
              colors={["#C73426", "#E99A95"]}
              fontColors={["#212121", "#212121"]}
              legends={[
                <span>
                  {t("dashboard.coach.teamAverage")}
                  {""}
                  <XlsxTooltip
                    arrow
                    title={t("dashboard.tooltip.teamAverage")}
                    placement="right"
                  >
                    <InfoIcon
                      className={styles.infoIcon}
                      fontSize="small"
                    ></InfoIcon>
                  </XlsxTooltip>
                </span>,
                t("dashboard.coach.coach"),
              ]}
              maxValue={metricsValue.max_value}
              data={metricsValue.mostFailedSubjects}
              labelX="Subjects"
              labelY="Sessions"
              hasFilter
            />

            <BarChart
              title={t("dashboard.coach.topSkillsToImprove")}
              colors={["#2B7EFB", "#C5DAFA"]}
              fontColors={["#212121", "#212121"]}
              legends={[
                <span>
                  {t("dashboard.coach.teamAverage")}
                  {""}
                  <XlsxTooltip
                    arrow
                    title={t("dashboard.tooltip.teamAverage")}
                    placement="right"
                  >
                    <InfoIcon
                      className={styles.infoIcon}
                      fontSize="small"
                    ></InfoIcon>
                  </XlsxTooltip>
                </span>,
                t("dashboard.coach.coach"),
              ]}
              maxValue={metricsValue.max_value}
              data={metricsValue.topSkillsToImproved}
              labelX="Subjects"
              labelY="Sessions"
              hasFilter
            />
          </Grid>
        ) : (
          <div>{t("dashboard.noDataYet")}</div>
        )}
      </div>
      <div className={styles.row}>
        {complianceMetricsValue ? (
          <ComplianceRate data={complianceMetricsValue} labelX={"Users"} />
        ) : (
          <div>{t("dashboard.noDataYet")}</div>
        )}
      </div>
      <div className={styles.row}>
        <Grid>
          {sessionTypeMetrics ? (
            <BarChart
              title={`${t("dashboard.coach.typeOfSession")} <span>${t(
                "dashboard.coach.comparedTo"
              )} <b>${getCoachName(compareValue)}</b></span>`}
              colors={["#4E2EE6", "#D0C2F7"]}
              fontColors={["#212121", "#000"]}
              legends={[
                t("dashboard.coach.individual"),
                getCoachName(compareValue),
              ]}
              data={sessionTypeMetrics.sessions_type}
              maxValue={sessionTypeMetrics.max_value}
              labelX={t("dashboard.coach.subjects")}
              labelY={t("dashboard.coach.session")}
              variant="left"
              hasFilter
            />
          ) : (
            <div>{t("dashboard.noDataYet")}</div>
          )}

          {barChartStackedData ? (
            <BarChartStacked
              title={t("dashboard.coach.sessionDuration")}
              colors={["#0A859A", "#17AECD", "#2FC8E6", "#83DFF3"]}
              fontColors={["#fff", "#fff", "#111", "#111"]}
              legends={[
                t("dashboard.coach.plan"),
                t("dashboard.coach.do"),
                t("dashboard.coach.check"),
                t("dashboard.coach.act"),
              ]}
              data={barChartStackedData}
              showTotal
              totalSuffix="mins"
              labelX={t("dashboard.coach.length")}
              labelY={t("dashboard.coach.minutes")}
            />
          ) : (
            <div>{t("dashboard.noDataYet")}</div>
          )}
        </Grid>
      </div>
      {/* Report Download Dialog */}
      <ReportDownload
        dialogOpen={dialogOpen}
        isCoordinator={IsCoordinator()}
        setDialogOpen={setDialogOpen}
        userIp={userIP}
      />
    </div>
  );
};

export default CampaignDashboard;